import { Injectable, Type } from "@angular/core";
import { NatCatalogRepository } from "@natiwi/core/network/repositories/catalog.repository";
import { NatRestAdapter } from "@natiwi/core/network/adapters/rest.adapter";
import { OrmProductKind } from "@natiwi/shared/models/product-kind.model";

export class NatProductKindRepository extends NatCatalogRepository<OrmProductKind> {

    constructor(adapter?: NatRestAdapter) {
        super(adapter);
        let repoUrl: string = '/productKinds';
        let repoModel: Type<OrmProductKind> = OrmProductKind;
        this.init(repoUrl, repoModel);
    }
}